import { useQuery } from "@tanstack/react-query";
import { getFeaturesEnabled } from "../Services/API/FeaturesEnabled";
import { FeaturesEnabledRequest, FeaturesEnabledResponse } from "../Types/FeaturesEnabled";

/**
 * @description Gets all features enabled data for the given type and search string
 * @returns UseQueryResult<FeaturesEnabledResponse>
 */
export const useFeaturesEnabledQuery = <T = FeaturesEnabledRequest>(
  request: FeaturesEnabledRequest,
  select?: (data: FeaturesEnabledResponse) => T,
) =>
  useQuery<FeaturesEnabledResponse, unknown, T | undefined>(
    ["featuresEnabled", { type: request.type, search: request.search }],
    () => getFeaturesEnabled(request),
    {
      select,
      staleTime: 1000 * 60 * 10, // 10 minutes
    },
  );
